import { useTranslation } from 'react-i18next';

import { Button, Drawer } from '@/components';
import { SolarProjectTechnology, ProjectTechnology, TechnologyCollection } from '@/features/projects/types';
import { SolarFormNew } from './solar-form-new';

export type SolarDrawerProps = {
  readonly technology: ProjectTechnology;
  readonly isOpen: boolean;
  readonly onSubmit: (collection: TechnologyCollection, item: SolarProjectTechnology, description?: string) => void;
  readonly onClose: () => void;
  readonly formId: string;
};

export function SolarDrawer({ formId, technology, isOpen, onSubmit, onClose }: SolarDrawerProps) {
  const { t } = useTranslation(['projects']);

  const footer = (
    <>
      <Button size="lg" color="neutral" onClick={onClose}>
        {t('Cancel')}
      </Button>
      <Button type="submit" form={formId} size="lg" color="primary">
        {t('Save')}
      </Button>
    </>
  );

  return (
    <Drawer title={t('Solar PV Details & Design')} open={isOpen} onClose={onClose} footer={footer}>
      <SolarFormNew
        id={formId}
        item={technology?.item as SolarProjectTechnology}
        onSubmit={(data: any) =>
          onSubmit(
            'projects_solar_technologies',
            { ...technology?.item, ...data },
            t('Solar PV Details has been updated')
          )
        }
      />
    </Drawer>
  );
}
